import { AnalyticsV2ElementType, ColumnCategory, SelectionFilterGroupSendCategory } from "../etc/types";
import { i18n } from "../../i18n";

export function getAnalyticsV2ElementTypeName(type: number): string {
    switch (type) {
        case AnalyticsV2ElementType.Project:
            return i18n.global.t('projects_label');
        case AnalyticsV2ElementType.Client:
            return i18n.global.t('clients_label');
        case AnalyticsV2ElementType.Job:
            return i18n.global.t('jobs_label');
        case AnalyticsV2ElementType.Person:
            return i18n.global.t('contacts_label');
        case AnalyticsV2ElementType.File:
            return i18n.global.t('files_label');
        case AnalyticsV2ElementType.Tag:
            return i18n.global.t('tags_upcase');
        case AnalyticsV2ElementType.Workload:
            return i18n.global.t('load_upcase');
        case AnalyticsV2ElementType.StorageItem:
            return i18n.global.t('storage_item_upcase');
        case AnalyticsV2ElementType.StorageItemMovement:
            return i18n.global.t('movement_upcase');
        default:
            return i18n.global.t('unknown_label');
    }
}

export function getSettingsTypeName(type: number, elType: AnalyticsV2ElementType): string {
    switch (type) {
        case ColumnCategory.Name:
            return elType === AnalyticsV2ElementType.Person ? i18n.global.t('contact_name') : i18n.global.t('name_upcase');
        case ColumnCategory.Tags:
            return i18n.global.t('tags_upcase');
        case ColumnCategory.Stage:
            return i18n.global.t('stage_label');
        case ColumnCategory.Clients:
            return elType === AnalyticsV2ElementType.Project ? i18n.global.t('client_label') : 
            (elType === AnalyticsV2ElementType.Person ? i18n.global.t('attached_clients') : i18n.global.t('clients_label'));
        case ColumnCategory.Address:
            return elType === AnalyticsV2ElementType.Client ? i18n.global.t('client_address') : i18n.global.t('address_upcase');
        case ColumnCategory.AttachedWorkers:
            return i18n.global.t('users_upcase');
        case ColumnCategory.Duration:
            return i18n.global.t('job_last_term');
        case ColumnCategory.LastJobDate:
            return i18n.global.t('last_job_date');
        case ColumnCategory.LastStageChangeDate:
            return i18n.global.t('last_stage_change');
        case ColumnCategory.JobCount:
            return i18n.global.t('jobs_count');
        case ColumnCategory.WorkerInJobCount:
            return i18n.global.t('job_users_count');
        case ColumnCategory.CreateDate:
            return elType === AnalyticsV2ElementType.Job ? i18n.global.t('job_create_date') : i18n.global.t('creation_date');
        case ColumnCategory.Parameters:
            return i18n.global.t('parameters_label');
        case ColumnCategory.Union:
            return i18n.global.t('holding');
        case ColumnCategory.ProjectCount:
            return i18n.global.t('projects_count');
        case ColumnCategory.Status:
            return i18n.global.t('status_label');
        case ColumnCategory.JobFinishDateTime:
            return elType === AnalyticsV2ElementType.Job ? i18n.global.t('job_close_date') : i18n.global.t('job_end_date');
        case ColumnCategory.Creator:
            return elType === AnalyticsV2ElementType.Job ? i18n.global.t('creator')+" / "+i18n.global.t('responsible') : 
            ([AnalyticsV2ElementType.Workload].includes(elType) ? i18n.global.t('responsible') : i18n.global.t('creator'));
        case ColumnCategory.JobText:
            return i18n.global.t('job_text');
        case ColumnCategory.EntityOfAttachment:
            return elType === AnalyticsV2ElementType.File ? 
                i18n.global.t('file_path_label') : 
                (elType === AnalyticsV2ElementType.Job ? i18n.global.t('client_label')+" / "+i18n.global.t('project_label') : i18n.global.t('file_attached_to'));
        case ColumnCategory.PersonPost:
            return i18n.global.t('position');
        case ColumnCategory.PersonDetails:
            return i18n.global.t('information');
        case ColumnCategory.Projects:
            return i18n.global.t('attached_projects');
        case ColumnCategory.LastChangeDate:
            return i18n.global.t('last_change_date');
        case ColumnCategory.ClientCount:
            return i18n.global.t('clients_count');
        case ColumnCategory.FileCount:
            return i18n.global.t('files_count');
        case ColumnCategory.PersonCount:
            return i18n.global.t('contacts_count');
        case ColumnCategory.GeneralCount:
            return i18n.global.t('count_type');
        case ColumnCategory.IpAddress:
            return i18n.global.t('ip_address');

        case ColumnCategory.ItemVendorCode:
            return i18n.global.t('item_vendor_code');
        case ColumnCategory.StoragesWithItem:
            return i18n.global.t('storages_with_item');
        case ColumnCategory.TotalAmount:
            return i18n.global.t('totalamount_type');
        case ColumnCategory.Bills:
            return i18n.global.t('bills');
        case ColumnCategory.SingleItemPrice:
            return i18n.global.t('singleitem_price_type');
        case ColumnCategory.Incomes:
            return i18n.global.t('incomes');
        case ColumnCategory.Expenses:
            return i18n.global.t('expenses');
        case ColumnCategory.Transfers:
            return i18n.global.t('transfers');
        case ColumnCategory.FinancialBurden:
            return i18n.global.t('financial_burden_type');
        case ColumnCategory.Notes:
            return i18n.global.t('notes_type');
        case ColumnCategory.LastMovementDate:
            return i18n.global.t('last_movement_date');
        case ColumnCategory.MovementType:
            return i18n.global.t('movement_type');
        case ColumnCategory.ResponsibleWorker:
            return i18n.global.t('responsible_worker');
        case ColumnCategory.SourceStorage:
            return i18n.global.t('source_storage');
        case ColumnCategory.ReceiverStorage:
            return i18n.global.t('receiver_storage');
        case ColumnCategory.Files:
            return i18n.global.t('files');
        case ColumnCategory.StorageItemNameParameters:
            return i18n.global.t('storage_item_name_parameters');
        case ColumnCategory.InitialProjectionElements:
            return i18n.global.t('initial_projection_elements');
        case ColumnCategory.MovementVendorCode:
            return i18n.global.t('movement_vendor_code');
        case ColumnCategory.Owner:
            return i18n.global.t('owner');
        case ColumnCategory.SpecialRules:
            return i18n.global.t('special_rules');
        default:
            return i18n.global.t('unknown_label');
    }
}

export function getFiltersTypeName(type: number, elType: AnalyticsV2ElementType): string {
    switch (type) {
        case SelectionFilterGroupSendCategory.Name:
            return (AnalyticsV2ElementType.Person == elType ? i18n.global.t('contact_name') : i18n.global.t('name_upcase'));
        case SelectionFilterGroupSendCategory.Tags:
            return i18n.global.t('tags_upcase');
        case SelectionFilterGroupSendCategory.ProjectStage:
            return i18n.global.t('stages');
        case SelectionFilterGroupSendCategory.Workers:
            return [AnalyticsV2ElementType.Client].includes(elType) ? i18n.global.t('user_in_role') : 
            [AnalyticsV2ElementType.Job].includes(elType) ? i18n.global.t('user_label') : i18n.global.t('users_upcase');
        case SelectionFilterGroupSendCategory.Clients:
            return i18n.global.t('clients_label');
        case SelectionFilterGroupSendCategory.Projects:
            return i18n.global.t('projects_label');
        case SelectionFilterGroupSendCategory.Address:
            return i18n.global.t('addresses');
        case SelectionFilterGroupSendCategory.CreateDate:
            return ![AnalyticsV2ElementType.Job].includes(elType) ? i18n.global.t('creation_date') : i18n.global.t('last_job_date');
        case SelectionFilterGroupSendCategory.JobStatus:
            return i18n.global.t('status_label');
        case SelectionFilterGroupSendCategory.JobText:
            return i18n.global.t('text_label');
        case SelectionFilterGroupSendCategory.PersonPost:
            return i18n.global.t('position');
        case SelectionFilterGroupSendCategory.PersonDetails:
            return i18n.global.t('information');
        case SelectionFilterGroupSendCategory.Creator:
            return [AnalyticsV2ElementType.Workload].includes(elType) ? i18n.global.t('responsible') : i18n.global.t('creator');
        case SelectionFilterGroupSendCategory.LastChangeDate:
            return i18n.global.t('last_change_date');
        case SelectionFilterGroupSendCategory.FileAttachment:
            return i18n.global.t('file_attached_to');
        case SelectionFilterGroupSendCategory.Parameters:
            return i18n.global.t('parameters_label');
        case SelectionFilterGroupSendCategory.TagStatus:
            return i18n.global.t('tag_type');
        case SelectionFilterGroupSendCategory.Lists:
            return i18n.global.t('lists_type');
        case SelectionFilterGroupSendCategory.LastMovementDate:
            return i18n.global.t('lastmovedate_type');
        case SelectionFilterGroupSendCategory.TotalAmount:
            return i18n.global.t('totalamount_type');
        case SelectionFilterGroupSendCategory.SingleItemPrice:
            return i18n.global.t('singleitem_price_type');
        case SelectionFilterGroupSendCategory.FinancialBurden:
            return i18n.global.t('financial_burden_type');
        case SelectionFilterGroupSendCategory.Count:
            return i18n.global.t('count_type');
        case SelectionFilterGroupSendCategory.Storages:
            return i18n.global.t('storage_type');
        case SelectionFilterGroupSendCategory.MovementTypes:
            return i18n.global.t('movement_type');
        case SelectionFilterGroupSendCategory.Notes:
            return i18n.global.t('notes_type');
        case SelectionFilterGroupSendCategory.StorageItemNames:
            return i18n.global.t('lstorageitem_type');
        case SelectionFilterGroupSendCategory.ProjectionRoles:
            return i18n.global.t('projection_roles_type');
        case SelectionFilterGroupSendCategory.Owner:
            return i18n.global.t('owner');
        case SelectionFilterGroupSendCategory.SpecialRules:
            return i18n.global.t('special_rules');
        default:
            return i18n.global.t('unknown_label');
    }
}
